"use client";

import {
  TimePicker,
  TimePickerContent,
  TimePickerHour,
  TimePickerInput,
  TimePickerInputGroup,
  TimePickerMinute,
  TimePickerPeriod,
  TimePickerSeparator,
  TimePickerTrigger,
} from "@repo/ui/components/ui/time-picker";
import { Field, FieldError, FieldLabel } from "@repo/ui/form-fields";
import { useFieldContext } from "@/shared/forms/form-context";

export interface TimeRangeFieldProps {
  label?: string;
  minuteStep?: number;
  disabled?: boolean;
}

export interface TimeRangeValue {
  start: string;
  end: string;
}

export function TimeRangeField({ label, minuteStep = 1, disabled }: TimeRangeFieldProps) {
  const field = useFieldContext<TimeRangeValue>();

  return (
    <Field errors={field.state.meta.errors} isTouched={field.state.meta.isTouched}>
      {label && <FieldLabel>{label}</FieldLabel>}
      <div className={`flex items-center gap-2 ${label ? "mt-1" : ""}`}>
        <TimePicker
          value={field.state.value.start}
          onValueChange={(value) => field.handleChange({ ...field.state.value, start: value })}
          minuteStep={minuteStep}
          disabled={disabled}
        >
          <TimePickerInputGroup>
            <TimePickerInput segment="hour" />
            <TimePickerSeparator />
            <TimePickerInput segment="minute" />
            <TimePickerInput segment="period" />
            <TimePickerTrigger />
          </TimePickerInputGroup>
          <TimePickerContent>
            <TimePickerHour />
            <TimePickerMinute />
            <TimePickerPeriod />
          </TimePickerContent>
        </TimePicker>
        <span className="text-muted-foreground">to</span>
        <TimePicker
          value={field.state.value.end}
          onValueChange={(value) => {
            field.handleChange({ ...field.state.value, end: value });
            field.handleBlur();
          }}
          minuteStep={minuteStep}
          disabled={disabled}
        >
          <TimePickerInputGroup>
            <TimePickerInput segment="hour" />
            <TimePickerSeparator />
            <TimePickerInput segment="minute" />
            <TimePickerInput segment="period" />
            <TimePickerTrigger />
          </TimePickerInputGroup>
          <TimePickerContent>
            <TimePickerHour />
            <TimePickerMinute />
            <TimePickerPeriod />
          </TimePickerContent>
        </TimePicker>
      </div>
      <FieldError />
    </Field>
  );
}
